import axios from 'axios'
import { authStorage } from '../storage/authStorage'
import { ensureLoginToken, retryWithFreshLoginToken } from './configureAxiosAuth'

const httpClient = axios.create()

httpClient.interceptors.request.use(async (config) => {
    const memberInfo = authStorage.getMember()

    // 站内请求统一携带当前成员标识，页面无需重复拼接 Authorization。
    if (memberInfo?.id && !config.headers?.Authorization) {
        config.headers = config.headers || {}
        config.headers.Authorization = memberInfo.id
    }

    const isAuthEndpoint = /\/member\/(login|logout|refreshToken)(?:\?|$)/.test(config.url || '')
    const token = isAuthEndpoint ? authStorage.getToken() : await ensureLoginToken()
    if (token) {
        // 新页面统一附带长期登录凭证；服务端仍核验当前成员的权限。
        config.headers = config.headers || {}
        config.headers['X-Auth-Token'] = token
    }

    return config
})

// 长期凭证失效时通过当前会话补发一次，并重试原请求。
httpClient.interceptors.response.use(response => response, error => retryWithFreshLoginToken(httpClient, error))

export default httpClient
